import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ListaService } from '../../_services/lista.service';
import { ConfirmationService } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { ProcesoProductivo } from '../../_models/proceso-productivo';
import { ProcesoProductivoService } from '../../_services/proceso-productivo.service';

@Component( {
  selector: 'app-proceso-productivo-editar',
  templateUrl: 'proceso-productivo-editar.component.html'
} )

export class ProcesoProductivoEditarComponent implements OnInit {
  formulario: FormGroup;
  procesoProductivo: ProcesoProductivo;
  carInformacionInicial = true;
  submitted = false;
  guardando = false;
  carTabla = true;
  lisProcesosProductivos: ProcesoProductivo[] = [];

  tabSeleccionado = 'PROCESO';

  constructor(
    private conServicio: ConfirmationService,
    private fb: FormBuilder,
    private serProcesoProductivo: ProcesoProductivoService,
    private route: ActivatedRoute,
    private lisServicio: ListaService,
    private navServicio: NavService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe( ( params: Params ) => {
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        this.serProcesoProductivo.obtenerPorId( params[ 'id' ] ).subscribe( procesoProducitvo => {
          this.procesoProductivo = procesoProducitvo;
          this.cargarInformacionInicial();
        } );
      } else {
        this.cargarInformacionInicial();
      }
    } );

  }

  cargarInformacionInicial() {

    this.formulario = this.fb.group( {
      idProcesoProductivo: [ this.procesoProductivo ? this.procesoProductivo.idProcesoProductivo : null ],
      codigo: [ this.procesoProductivo ? this.procesoProductivo.codigo : null, [ Validators.required ] ],
      nombre: [ this.procesoProductivo ? this.procesoProductivo.nombre : null, [ Validators.required ] ],
      indicadorEstructuraAgro: [ this.procesoProductivo ? this.procesoProductivo.indicadorEstructuraAgro : false, [ Validators.required ] ],
      indicadorEstructuraPecuaria: [ this.procesoProductivo ? this.procesoProductivo.indicadorEstructuraPecuaria : false, [ Validators.required ] ],
      indicadorHabilitado: [ this.procesoProductivo ? this.procesoProductivo.indicadorHabilitado : true, [ Validators.required ] ],

    } );

    this.serProcesoProductivo.listado().subscribe( reg => {
      this.lisProcesosProductivos = reg;
      this.carTabla = false;
      this.carInformacionInicial = false;
    } );

  }

  get f() {
    return this.formulario.controls;
  }

  onSubmit() {

    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      const formulario = this.formulario.getRawValue();
      if ( !formulario.indicadorEstructuraAgro && !formulario.indicadorEstructuraPecuaria ) {
        this.navServicio.setMesage( 0, {
          severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'PROCESOPRODUCTIVO.MSG_ERRORINDICADOR' )
        } );
        this.guardando = false;
        this.submitted = false;
      } else {
        /** Actualizar Proceso productivo */
        if ( formulario.idInsumoPecuario ) {
          if ( this.verificarCodigo( formulario ) ) {
            this.navServicio.setMesage( 0, {
              severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'PROCESOPRODUCTIVO.MSG_ERRORCODIGO' )
            } );
            this.guardando = false;
            this.submitted = false;
          } else {
            this.serProcesoProductivo.actualizar( formulario ).subscribe( insumoPecuario => {
              this.procesoProductivo = insumoPecuario;
              this.submitted = false;
              this.guardando = false;
              this.navServicio.setMesage( 0, {
                severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
                detail: this.navServicio.buscarMensaje( 'INSUMOPECUARIO.MSG_REGACTU' )
              } );
              this.cambiarTabSeleccionado( 'VARIABLE' );
            } );
          }
        } else {
          if ( this.verificarCodigo( formulario ) ) {
            this.navServicio.setMesage( 0, {
              severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'PROCESOPRODUCTIVO.MSG_ERRORCODIGO' )
            } );
            this.guardando = false;
            this.submitted = false;
          } else {
            /** Crear Proceso productivo */
            this.serProcesoProductivo.crear( formulario ).subscribe( insumoPecuario => {
              this.procesoProductivo = insumoPecuario;
              this.f.idProcesoProductivo.setValue( this.procesoProductivo.idProcesoProductivo );
              this.f.codigo.setValue( this.procesoProductivo.codigo );
              this.submitted = false;
              this.guardando = false;
              this.navServicio.setMesage( 0, {
                severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
                detail: this.navServicio.buscarMensaje( 'INSUMOPECUARIO.MSG_REGGUAR' )
              } );
              this.cambiarTabSeleccionado( 'VARIABLE' );
            } );
          }
        }
      }
    }

  }

  verificarCodigo( item: ProcesoProductivo ): boolean {
    if ( item.idProcesoProductivo !== '' && item.idProcesoProductivo !== null && item.idProcesoProductivo !== undefined ) {
      return this.lisProcesosProductivos.find( x => x.codigo === item.codigo && x.idProcesoProductivo !== item.idProcesoProductivo ) ? true : false;
    } else {
      return this.lisProcesosProductivos.find( x => x.codigo === item.codigo ) ? true : false;
    }
  }


  abrirAcordeon( evento: any ) {
    switch ( evento.index ) {
      case 0: {
        this.tabSeleccionado = 'PROCESO';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'VARIABLE';
        break;
      }
      default: {
        break;
      }
    }
  }

  cambiarTabSeleccionado( tab: string ) {
    this.tabSeleccionado = tab;
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.router.navigate( [ 'apl/proceso-productivo/' ] );
        },
        reject: () => {
        }
      } );
    } else {
      this.router.navigate( [ 'apl/proceso-productivo/' ] );
    }
  }


}
